<div class="relative">
  @if (triggerType() === 'button') {
    <button class="mdw-button mdw-secondary" [icon]="icon()" (click)="picker.open()">
      <p class="pad-left-050" [class.secondary]="isPlaceholder()">{{ displayValue() }}</p>
    </button>
  } @else {
    <button
      type="button"
      class="mdw-date-trigger relative fill-width hflex-100 flex-align-items-center flex-justify-content-space-between"
      (click)="picker.open()"
    >
      <div class="hflex-100 flex-align-items-center">
        <mdw-icon class="small-icon" [icon]="icon()"></mdw-icon>
        <p [class.secondary]="isPlaceholder()">{{ displayValue() }}</p>
      </div>

      <mdw-icon class="dropdown-icon small-icon chevron" [icon]="icons.DropdownArrow"></mdw-icon>
    </button>
  }
  <input
    #dateInput
    class="hidden"
    matInput
    [ngModel]="value()"
    (ngModelChange)="value.set($event)"
    type="date"
    [matDatepicker]="picker"
    [matDatepickerFilter]="dateFilter"
  />
  <mat-datepicker #picker [calendarHeaderComponent]="header"></mat-datepicker>
</div>
